import { render } from "./MusicMenuComp.vue?vue&type=template&id=7aa99782&scoped=true"
import script from "./MusicMenuComp.vue?vue&type=script&lang=js"
export * from "./MusicMenuComp.vue?vue&type=script&lang=js"

import "./MusicMenuComp.vue?vue&type=style&index=0&id=7aa99782&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aa99782"]])

export default __exports__